var _defs, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisegno(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 508 285.75",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.79588,
    cy: 532.37427,
    r: 11.394896,
    transform: "rotate(-45)",
    fill: "#2f2e41",
    id: "circle1035",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.36993,
    cy: 366.03244,
    r: 3.8944657,
    transform: "rotate(-12.48125)",
    fill: "#ffffff",
    id: "circle1037",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.04703,
    cy: 364.7095,
    r: 1.2981596,
    transform: "rotate(-12.48125)",
    fill: "#3f3d56",
    id: "circle1039",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 481.20984,263.52733 c -4.66016,-0.009 -7.93161,-0.84099 -7.92381,-5.06302 0.008,-4.22203 3.79194,-7.63769 8.45212,-7.62908 4.66017,0.009 8.43165,3.43823 8.42385,7.66026 -0.008,4.22205 -4.29199,5.04044 -8.95216,5.03184 z",
    fill: "#304ffe",
    id: "path1041",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 499.51986,273.13555 c -1.3367,4.6372 -5.23971,7.88329 -9.31104,10.64079 q -0.85271,0.57766 -1.70595,1.12872 c -0.004,0.002 -0.008,0.005 -0.0117,0.007 -0.0274,0.0176 -0.0548,0.0352 -0.0803,0.0529 -0.11741,0.0757 -0.23485,0.1514 -0.35127,0.22622 l 0.0639,0.0287 c 0,0 0.0628,0.0334 -0.006,0.005 -0.0204,-0.009 -0.0419,-0.0162 -0.0623,-0.0248 -2.36519,-0.95392 -4.77239,-1.97813 -6.58495,-3.76513 -1.88026,-1.85569 -2.97908,-4.76624 -1.96094,-7.20408 a 4.654497,4.654497 0 0 1 0.50398,-0.90457 c 0.0826,-0.11818 0.17153,-0.23129 0.26414,-0.3423 a 4.9889595,4.9889595 0 0 1 8.56869,1.516 c 0.29911,-2.78494 -1.99728,-5.11774 -4.20723,-6.839 -2.21092,-1.7204 -4.72314,-3.59395 -5.15058,-6.36343 -0.23869,-1.5409 0.29715,-3.03418 1.27324,-4.23294 0.0302,-0.0364 0.0604,-0.0728 0.0915,-0.10821 a 7.2809337,7.2809337 0 0 1 4.67973,-2.5106 c 3.39017,-0.35233 6.68319,1.44214 9.14607,3.79926 3.96399,3.79246 6.3604,9.61766 4.84082,14.89013 z",
    fill: "#e6e6e6",
    id: "path1043",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 493.14758,267.07015 a 12.377116,12.377116 0 0 1 1.48284,3.2705 10.747288,10.747288 0 0 1 0.37148,3.17415 13.769911,13.769911 0 0 1 -1.80347,6.26655 19.817926,19.817926 0 0 1 -2.98961,3.99499 q -0.85271,0.57766 -1.70595,1.12872 c -0.004,0.002 -0.008,0.005 -0.0117,0.007 -0.0274,0.0176 -0.0548,0.0352 -0.0803,0.0529 -0.11741,0.0757 -0.23485,0.1514 -0.35127,0.22622 0,0 0.12675,0.0621 0.058,0.0341 -0.0204,-0.009 -0.0419,-0.0162 -0.0623,-0.0248 a 10.955038,10.955038 0 0 0 -3.50547,-9.43261 11.048886,11.048886 0 0 0 -4.53643,-2.44116 c 0.0826,-0.11818 0.17153,-0.23129 0.26414,-0.3423 a 11.4554,11.4554 0 0 1 1.89088,0.71552 11.224683,11.224683 0 0 1 5.07518,4.89307 11.475995,11.475995 0 0 1 1.2495,6.29743 c 0.0972,-0.0881 0.19447,-0.17804 0.28884,-0.26716 1.79729,-1.67563 3.39364,-3.59898 4.474,-5.81869 a 12.810191,12.810191 0 0 0 1.3414,-6.06093 c -0.0882,-2.28952 -1.00039,-4.4102 -2.32118,-6.25638 a 26.814338,26.814338 0 0 0 -5.08278,-5.23833 30.468866,30.468866 0 0 0 -6.32147,-3.90275 0.219075,0.219075 0 0 1 -0.11025,-0.28115 0.18631958,0.18631958 0 0 1 0.0915,-0.10822 0.16221075,0.16221075 0 0 1 0.14087,0.006 c 0.27885,0.12837 0.55576,0.2585 0.83044,0.39425 a 30.814676,30.814676 0 0 1 6.36653,4.19964 c 1.87399,1.5977 3.63825,3.42306 4.95649,5.51352 z",
    fill: "#ffffff",
    id: "path1045",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.96161,
    cy: 284.90576,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse1047",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.88507,
    cy: 284.76154,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse1049",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.39348,
    cy: 431.90894,
    rx: 5.6974554,
    ry: 1.7886018,
    transform: "rotate(-29.96257)",
    fill: "#2f2e41",
    id: "ellipse1051",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -203.69189,
    cy: 428.42941,
    r: 11.394902,
    transform: "rotate(-80.782519)",
    fill: "#2f2e41",
    id: "circle1053",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.07681,
    y: 278.63138,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect1055",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.00027,
    y: 278.63138,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect1057",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.55789,
    cy: 266.80374,
    r: 3.8944602,
    fill: "#ffffff",
    id: "circle1059",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.55789,
    cy: 266.80374,
    r: 1.298157,
    fill: "#3f3d56",
    id: "circle1061",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 379.21599,259.0916 c -0.92008,-4.12057 2.02106,-8.28423 6.56924,-9.2998 4.54817,-1.01557 8.98107,1.50153 9.90115,5.6221 0.92008,4.12056 -2.09415,5.6403 -6.64233,6.65586 -4.54817,1.01556 -8.90798,1.14241 -9.82806,-2.97816 z",
    fill: "#e6e6e6",
    id: "path1063",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -77.151978,
    cy: 454.32672,
    rx: 1.7886018,
    ry: 5.6974525,
    transform: "rotate(-64.62574)",
    fill: "#2f2e41",
    id: "ellipse1065",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 384.67228,273.79935 c 0,1.11526 2.87159,3.3175 6.05804,3.3175 3.18645,0 6.17409,-3.13981 6.17409,-4.25506 0,-1.11524 -2.98765,0.21637 -6.17409,0.21637 -3.18644,0 -6.05804,-0.39407 -6.05804,0.72119 z",
    fill: "#ffffff",
    id: "path1067",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.0025,
    cy: 284.90576,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse1069",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.07904,
    cy: 284.76154,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse1071",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -23.38975,
    cy: 492.25122,
    rx: 1.7886018,
    ry: 5.6974554,
    transform: "rotate(-60.03743)",
    fill: "#2f2e41",
    id: "ellipse1073",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.6947,
    cy: 269.68854,
    r: 11.3949,
    fill: "#2f2e41",
    id: "circle1075",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.42557,
    y: 278.63138,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect1077",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.50208,
    y: 278.63138,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect1079",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.02496,
    cy: 266.80374,
    r: 3.8944602,
    fill: "#ffffff",
    id: "circle1081",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.16277,
    cy: 487.46313,
    rx: 1.3018955,
    ry: 1.2927356,
    transform: "rotate(-44.97427)",
    fill: "#3f3d56",
    id: "ellipse1083",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 428.92006,262.06975 c -4.54818,-1.01555 -7.56242,-2.53529 -6.64233,-6.65586 0.92008,-4.12057 5.35298,-6.63766 9.90115,-5.62209 4.54817,1.01557 7.48933,5.17923 6.56924,9.29979 -0.92008,4.12057 -5.27989,3.99372 -9.82806,2.97816 z",
    fill: "#304ffe",
    id: "path1085",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.41922,
    cy: 376.19855,
    rx: 1.7886018,
    ry: 5.697453,
    transform: "rotate(-14.87459)",
    fill: "#2f2e41",
    id: "ellipse1087",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 425.11315,273.07833 c -2.09197,0 -4.05344,-1.33161 -4.05344,-0.21637 0,1.11525 1.96146,4.25506 4.05344,4.25506 2.09198,0 3.97725,-2.20224 3.97725,-3.3175 0,-1.11526 -1.88528,-0.72119 -3.97725,-0.72119 z",
    fill: "#ffffff",
    id: "path1089",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 410.38706,250.79536 h -1.01194 a 3.4230257,3.4230257 0 0 1 -3.41918,-3.41917 v -0.84956 c 0,-2.10427 0.39869,-3.86617 1.18507,-5.23676 a 27.546866,27.546866 0 0 1 3.31841,-4.45865 19.650379,19.650379 0 0 0 2.25632,-2.7196 4.5746458,4.5746458 0 0 0 0.71262,-2.53007 c 0,-2.11085 -1.37524,-3.13702 -4.2044,-3.13702 a 17.07247,17.07247 0 0 0 -4.63421,0.69556 3.9013077,3.9013077 0 0 1 -4.97218,-3.75132 v -1.71979 a 3.8267825,3.8267825 0 0 1 2.25749,-3.50741 20.65955,20.65955 0 0 1 8.4164,-1.65571 c 3.02798,0 5.76141,0.50862 8.12456,1.51153 2.36743,1.00524 4.23786,2.42272 5.55922,4.21318 a 10.147284,10.147284 0 0 1 1.99394,6.15002 c 0,2.37595 -0.64867,4.44533 -1.92792,6.15065 -1.2653,1.68801 -3.07914,3.53596 -5.39115,5.49282 a 38.418576,38.418576 0 0 0 -3.45638,3.25613 6.0108491,6.0108491 0 0 0 -1.43699,2.67529 3.40995,3.40995 0 0 1 -3.36968,2.83988 z",
    fill: "#304ffe",
    id: "path1091",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 409.82443,266.87448 h -0.13345 a 6.337083,6.337083 0 0 1 0,-12.67416 h 0.13345 a 6.337083,6.337083 0 1 1 0,12.67416 z",
    fill: "#304ffe",
    id: "path1093",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 451.0081,286.1069 h -82.28542 a 0.264585,0.264585 0 0 1 0,-0.52917 h 82.28542 a 0.264585,0.264585 0 0 1 0,0.52917 z",
    fill: "#cccccc",
    id: "path1095",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 506.5706,286.1069 h -43.92084 a 0.264585,0.264585 0 0 1 0,-0.52917 h 43.92084 a 0.264585,0.264585 0 0 1 0,0.52917 z",
    fill: "#cccccc",
    id: "path1097",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 473.77582,
    cy: 285.90887,
    rx: 5.6974525,
    ry: 1.7886018,
    transform: "rotate(-1.1204109)",
    fill: "#2f2e41",
    id: "ellipse1099",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 476.4508,236.62982 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32292 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32291 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32291 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87916,-8.99584 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path1101",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 479.6258,232.1319 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path1103",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 275.95552,32.421434 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path1105",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 421.15289,205.67356 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path1107",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.44766,
    cy: 245.67064,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1109",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.65601,
    cy: 239.58522,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.01434,
    cy: 254.40189,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1113",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.048038,
    y: 173.882,
    width: 107.21968,
    height: 0.52916664,
    fill: "#cccccc",
    id: "rect2774",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.30861,
    y: 124.92396,
    width: 0.52916664,
    height: 49.222061,
    fill: "#cccccc",
    id: "rect2776",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.422073,
    y: 149.27046,
    width: 90.302238,
    height: 0.52916664,
    fill: "#cccccc",
    id: "rect2778",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.64939,212.06184 a 11.104584,11.104584 0 0 1 -2.74905,7.31838 c -0.15878,0.18256 -0.32544,0.35719 -0.49468,0.52916 h -15.7427 c -0.16937,-0.17197 -0.33616,-0.3466 -0.4948,-0.52916 a 11.071844,11.071844 0 0 1 -2.27286,-4.08781 c 0,0 0.003,0 0,-0.003 a 11.117056,11.117056 0 0 1 -0.4762,-3.22792 10.797117,10.797117 0 0 1 0.082,-1.34673 11.115815,11.115815 0 0 1 22.06363,-0.0291 11.235118,11.235118 0 0 1 0.0846,1.37583 z",
    fill: "#2f2e41",
    id: "path2780",
    style: {
      strokeWidth: 0.264583
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "374.43,358.002 374.55,357.942 374.58,358.002 375.58,360.002 370.44,360.002 ",
    fill: "#2f2e41",
    id: "polygon2782",
    transform: "matrix(0.26458333,0,0,0.26458333,2.1523593,124.65892)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.47,358.002 406.5,357.942 406.62,358.002 410.61,360.002 405.47,360.002 ",
    fill: "#2f2e41",
    id: "polygon2784",
    transform: "matrix(0.26458333,0,0,0.26458333,2.1523593,124.65892)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 114.75579,
    cy: 209.34331,
    r: 3.7990568,
    fill: "#ffffff",
    id: "circle2786",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -68.334259,
    cy: 228.78951,
    rx: 1.2610677,
    ry: 1.2700001,
    transform: "rotate(-45)",
    fill: "#3f3d56",
    id: "ellipse2788",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.30278,199.96954 c 0.16716,-4.11522 -3.37956,-7.60085 -7.92184,-7.78535 -4.54227,-0.18449 -8.36001,3.00197 -8.52718,7.11719 -0.16717,4.11522 2.9903,5.05022 7.53257,5.23474 4.54228,0.18452 8.74928,-0.45136 8.91645,-4.56658 z",
    fill: "#304ffe",
    id: "path2790",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.58695,216.44289 a 2.5327111,2.5327111 0 1 1 -4.98352,0.90721 l -7.9e-4,-0.005 c -0.24918,-1.3764 0.81502,-1.86346 2.19142,-2.11262 1.3764,-0.24917 2.54382,-0.1661 2.79298,1.21031 z",
    fill: "#ffffff",
    id: "path2792",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 173.33777,219.37976 H 43.162775 a 4.7624999,4.7624999 0 0 0 0,9.52499 H 173.33777 a 4.7624999,4.7624999 0 0 0 0,-9.52499 z",
    fill: "#cccccc",
    id: "path2794",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 163.54819,178.63392 v 41.01042 h -0.52917 v -41.01042 q 0,-2.13122 -0.16666,-4.22275 c -0.0133,-0.17728 -0.0265,-0.35189 -0.0424,-0.52916 a 53.091709,53.091709 0 0 0 -8.25505,-24.08238 c -0.11369,-0.17727 -0.22751,-0.35189 -0.34391,-0.52917 a 53.437535,53.437535 0 0 0 -44.37324,-24.07973 c -0.0873,-0.003 -0.17725,-0.003 -0.26458,-0.003 -0.0873,0 -0.17725,0 -0.26459,0.003 q -1.50417,0.004 -2.98444,0.0952 a 53.040838,53.040838 0 0 0 -11.422168,1.94998 52.81105,52.81105 0 0 0 -6.199103,2.19605 53.775953,53.775953 0 0 0 -23.767542,19.83845 c -0.116401,0.17728 -0.230219,0.3519 -0.343908,0.52917 a 53.091709,53.091709 0 0 0 -8.25505,24.08238 c -0.0159,0.17727 -0.02907,0.35188 -0.04238,0.52916 q -0.166645,2.09153 -0.166645,4.22275 v 41.01042 h -0.529167 v -41.01042 q 0,-2.413 0.209021,-4.77044 a 53.568975,53.568975 0 0 1 8.532817,-24.64593 54.02096,54.02096 0 0 1 30.845145,-22.6113 53.670366,53.670366 0 0 1 11.38237,-1.86266 q 1.49216,-0.0833 3.00563,-0.0847 a 54.035324,54.035324 0 0 1 53.76598,49.21779 q 0.20639,2.3495 0.20904,4.75721 z",
    fill: "#3f3d56",
    id: "path2796",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.660065,257.49939 c 14.978585,0.25581 14.976225,22.53615 -5.29e-4,22.78978 -14.978099,-0.2558 -14.975753,-22.53614 5.29e-4,-22.78978 z",
    fill: "#2f2e41",
    id: "path2798",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.467453,
    y: 277.83713,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect2800",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.390938,
    y: 277.83713,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect2802",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.352229,283.02973 c 3.740573,-0.0266 3.740613,2.19033 -1.56e-4,2.16358 -3.74042,0.0266 -3.740462,-2.19032 1.56e-4,-2.16358 z",
    fill: "#2f2e41",
    id: "path2804",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.275724,282.88549 c 3.740576,-0.0266 3.740616,2.19033 -1.56e-4,2.16358 -3.74042,0.0266 -3.74046,-2.19032 1.56e-4,-2.16358 z",
    fill: "#2f2e41",
    id: "path2806",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.948546,262.11503 c 5.093124,0.0229 5.092704,7.76676 -2.36e-4,7.78892 -5.092888,-0.0229 -5.092449,-7.76674 2.36e-4,-7.78892 z",
    fill: "#ffffff",
    id: "path2808",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.948546,264.71134 c 1.684292,-0.0246 1.684316,2.62113 -1.17e-4,2.59631 -1.684173,0.0246 -1.684197,-2.62112 1.17e-4,-2.59631 z",
    fill: "#3f3d56",
    id: "path2810",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.60662,258.29736 c -2.140796,-9.76085 14.257914,-13.42083 16.47049,-3.67718 0.92,4.12007 -2.094238,5.63981 -6.64241,6.65537 -4.548171,1.01555 -8.907981,1.1424 -9.82808,-2.97819 z",
    fill: "#cccccc",
    id: "path2812",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.627196,226.90862 c 2.654494,-6.95154 6.000444,-5.6725 3.341354,1.27735 -2.6544,6.95135 -6.000361,5.67231 -3.341354,-1.27735 z",
    fill: "#2f2e41",
    id: "path2814",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.517847,234.32675 c 2.651805,-14.74421 24.644083,-11.17297 22.495423,3.65098 -2.651723,14.74374 -24.644011,11.1725 -22.495423,-3.65098 z",
    fill: "#2f2e41",
    id: "path2816",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.57299,
    y: 245.09482,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect2818",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.49646,
    y: 245.09482,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect2820",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.457779,250.28743 c 3.740574,-0.0266 3.740616,2.19033 -1.53e-4,2.16359 -3.740423,0.0266 -3.740452,-2.19033 1.53e-4,-2.16359 z",
    fill: "#2f2e41",
    id: "path2822",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.381258,250.14319 c 3.740574,-0.0266 3.740616,2.19033 -1.53e-4,2.16358 -3.740423,0.0266 -3.740462,-2.19033 1.53e-4,-2.16358 z",
    fill: "#2f2e41",
    id: "path2824",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.712173,225.55505 c -2.140794,-9.76085 14.257885,-13.42082 16.470479,-3.67721 0.920001,4.12006 -2.094238,5.6398 -6.642409,6.65537 -4.548172,1.01557 -8.907987,1.14242 -9.82807,-2.97816 z",
    fill: "#304ffe",
    id: "path2826",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 72.783339,228.42318 c 0.805333,-2.16706 11.465015,2.88864 10.295467,4.88332 -0.805183,2.16679 -11.464857,-2.88891 -10.295467,-4.88332 z",
    fill: "#2f2e41",
    id: "path2828",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -44.468933,
    cy: 246.9111,
    rx: 1.7447895,
    ry: 5.5578799,
    transform: "rotate(-40.645161)",
    fill: "#2f2e41",
    id: "ellipse2830",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -96.379501,
    cy: 219.81725,
    rx: 5.5578799,
    ry: 1.7447895,
    transform: "rotate(-49.354839)",
    fill: "#2f2e41",
    id: "ellipse2832",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 187.88985,174.66563 h -15.61041 a 2.645835,2.645835 0 0 1 0,-5.29167 v 0.52917 a 2.1166666,2.1166666 0 0 0 0,4.23333 h 15.61041 z",
    fill: "#e6e6e6",
    id: "path2836",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 231.98994,228.81064 v -0.52917 a 2.1166666,2.1166666 0 0 0 0,-4.23333 h -15.61042 v -0.52917 h 15.61042 a 2.645835,2.645835 0 0 1 0,5.29167 z",
    fill: "#e6e6e6",
    id: "path2838",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 213.28985,140.26979 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172.79352,109.95854 H 157.1831 a 2.645835,2.645835 0 0 1 0,-5.29167 v 0.52917 a 2.1166666,2.1166666 0 0 0 0,4.23333 h 15.61042 z",
    fill: "#e6e6e6",
    id: "path2842",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.489269,208.09737 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 H 1.8788519 v -0.52916 H 17.489269 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2846",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.947021,160.14096 H 5.3366042 a 2.645835,2.645835 0 0 1 0,-5.29167 v 0.52917 a 2.1166666,2.1166666 0 0 0 0,4.23333 H 20.947021 Z",
    fill: "#e6e6e6",
    id: "path2850",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 167.51694,261.97813 v -0.52917 a 2.1166666,2.1166666 0 0 0 0,-4.23333 h -15.61042 v -0.52917 h 15.61042 a 2.645835,2.645835 0 0 1 0,5.29167 z",
    fill: "#e6e6e6",
    id: "path2858",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.76694,264.62396 h -15.61042 a 2.645835,2.645835 0 0 1 0,-5.29167 v 0.52917 a 2.1166666,2.1166666 0 0 0 0,4.23333 h 15.61042 z",
    fill: "#e6e6e6",
    id: "path2860",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.050275,269.91563 H 16.439858 a 2.645835,2.645835 0 0 1 0,-5.29167 v 0.52917 a 2.1166666,2.1166666 0 0 0 0,4.23333 h 15.610417 z",
    fill: "#e6e6e6",
    id: "path2864",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 425.04834,126.8263 c 0.92008,-4.12056 -2.02107,-8.28421 -6.56924,-9.29978 -4.54817,-1.01558 -8.98107,1.50154 -9.90115,5.6221 -0.92009,4.12057 2.09415,5.64031 6.64232,6.65586 4.54818,1.01555 8.90797,1.14241 9.82807,-2.97818 z",
    fill: "#e6e6e6",
    id: "path4294",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -235.18224,
    cy: -346.20758,
    rx: 5.6974554,
    ry: 1.7886018,
    transform: "matrix(-0.35702868,-0.93409342,-0.93409342,0.35702868,0,0)",
    fill: "#2f2e41",
    id: "ellipse4296",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -170.26775,
    cy: -395.72531,
    r: 11.394902,
    transform: "matrix(-0.16018236,-0.98708744,-0.98708744,0.16018236,0,0)",
    fill: "#2f2e41",
    id: "circle4298",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -423.08197,
    y: 113.62376,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect4300",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -416.15851,
    y: 113.62376,
    width: 3.4617395,
    height: 6.2022858,
    fill: "#2f2e41",
    id: "rect4302",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -420.19717,
    cy: 119.89816,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse4304",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -413.27371,
    cy: 119.75393,
    rx: 2.884789,
    ry: 1.0817965,
    fill: "#2f2e41",
    id: "ellipse4306",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -417.60089,
    cy: 101.79614,
    r: 3.8944602,
    fill: "#ffffff",
    id: "circle4308",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -417.60089,
    cy: 101.79614,
    r: 1.298157,
    fill: "#3f3d56",
    id: "circle4310",
    style: {
      strokeWidth: 0.264583
    },
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 428.94279,94.083991 c 0.92008,-4.12057 -2.02107,-8.284232 -6.56924,-9.299802 -4.54817,-1.01557 -8.98107,1.50153 -9.90115,5.622102 -0.92008,4.12057 2.09415,5.6403 6.64232,6.65586 4.54817,1.01556 8.90798,1.14242 9.82807,-2.97816 z",
    fill: "#304ffe",
    id: "path4312",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -274.38272,
    cy: -346.57788,
    rx: 1.7886018,
    ry: 5.6974525,
    transform: "matrix(-0.42852927,-0.9035279,-0.9035279,0.42852927,0,0)",
    fill: "#2f2e41",
    id: "ellipse4314",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 423.4865,108.79175 c 0,1.11526 -2.87159,3.31749 -6.05805,3.31749 -3.18645,0 -6.17408,-3.13981 -6.17408,-4.25505 0,-1.11524 2.98765,0.21636 6.17408,0.21636 3.18644,0 6.05805,-0.39406 6.05805,0.7212 z",
    fill: "#ffffff",
    id: "path4316",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 264.34435,252.52882 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 454.4719,180.43189 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.44447,163.54959 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382.21114,160.11001 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.87381,
    cy: 172.41707,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1109-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.33774,
    cy: 209.89903,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.80341,
    cy: 181.23518,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 380.94503,195.76723 v -0.52917 a 2.1166666,2.1166666 0 0 0 0,-4.23333 h -15.61042 v -0.52917 h 15.61042 a 2.645835,2.645835 0 0 1 0,5.29167 z",
    fill: "#e6e6e6",
    id: "path2838-0",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 225.45048,171.75993 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 368.12368,118.84668 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 225.92006,93.12317 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23333 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29165 z",
    fill: "#e6e6e6",
    id: "path2840-5",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.63876,
    cy: 110.36141,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 238.08069,124.61331 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-5",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 269.69053,89.87406 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 463.69661,143.60652 v -0.52917 a 2.11667,2.11667 0 0 0 0,-4.23332 H 448.0862 v -0.52917 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840-5-7",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.66562,
    cy: 148.22392,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-1-0",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 265.34169,161.46615 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.3229 v -6.87918 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32291 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32291 v 6.87918 a 1.3244327,1.3244327 0 0 1 -1.32292,1.3229 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87918 a 0.79461782,0.79461782 0 0 0 0.79375,0.79374 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79374 v -6.87918 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-5-3",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 311.5917,129.7559 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32291 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87917,-8.99582 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-1-9",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 309.21758,65.862167 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.93628,
    cy: 83.100395,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-6",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 321.37821,97.352307 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 352.98805,62.613057 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.87916 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87916 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-0",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 154.23371,30.018992 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 H 138.6233 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840-1-3",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.64091,
    cy: 63.411892,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-6-5",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 179.01517,72.110634 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-1-8",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 84.794565,47.83052 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23333 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29165 z",
    fill: "#e6e6e6",
    id: "path2840-5-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.957345,32.37116 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.879173 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.879173 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.995833 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.879173 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.879173 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-1-8-6",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 217.69268,42.924552 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.879158 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.879158 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.995828 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.879158 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.879158 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-0-7",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.704187,84.036172 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840-1-3-3",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.42289,
    cy: 101.2744,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-6-5-8",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.73253,
    cy: 54.522003,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-6-5-8-9",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 58.864817,115.52631 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-1-8-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 90.474657,80.787062 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.879158 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.879158 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.995828 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.879158 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.879158 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-0-7-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 422.8051,38.601163 v -0.52916 a 2.11667,2.11667 0 0 0 0,-4.23334 h -15.61041 v -0.52916 h 15.61041 a 2.6458333,2.6458333 0 0 1 0,5.29166 z",
    fill: "#e6e6e6",
    id: "path2840-1-3-3-1",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 471.5238,
    cy: 55.839386,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-67-6-5-8-3",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 434.96573,70.091296 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.3229 v -6.879175 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.879175 a 1.3244327,1.3244327 0 0 1 -1.32292,1.3229 z m -6.87916,-8.995825 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.879175 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.879175 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-1-8-1-0",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 466.57557,35.352053 h -6.87917 a 1.3244327,1.3244327 0 0 1 -1.32291,-1.32292 v -6.879158 a 1.3244327,1.3244327 0 0 1 1.32291,-1.32292 h 6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.879158 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32292 z m -6.87917,-8.995828 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.879158 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.879158 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5225-8-5-0-7-1-6",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.835925,191.04605 h -6.87916 a 1.3244327,1.3244327 0 0 1 -1.32292,-1.32291 v -6.87917 a 1.3244327,1.3244327 0 0 1 1.32292,-1.32292 h 6.87916 a 1.3244327,1.3244327 0 0 1 1.32292,1.32292 v 6.87917 a 1.3244327,1.3244327 0 0 1 -1.32292,1.32291 z m -6.87916,-8.99583 a 0.79461782,0.79461782 0 0 0 -0.79375,0.79375 v 6.87917 a 0.79461782,0.79461782 0 0 0 0.79375,0.79375 h 6.87916 a 0.79461782,0.79461782 0 0 0 0.79375,-0.79375 v -6.87917 a 0.79461782,0.79461782 0 0 0 -0.79375,-0.79375 z",
    fill: "#f2f2f2",
    id: "path5223-4-7-9",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.765854,
    cy: 134.28571,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1111-6-6",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.35657,
    cy: 232.22339,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1109-14",
    style: {
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.74649,
    cy: 228.18471,
    r: 1.7110312,
    fill: "#f2f2f2",
    id: "circle1109-14-5",
    style: {
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisegno);
export default __webpack_public_path__ + "static/media/disegno.951e0c51d35a81afe88f4b52e88d6d13.svg";
export { ForwardRef as ReactComponent };